/** Public Langfuse UI base (e.g. https://langfuse.trust-forge.ai). */
export function getLangfuseUiBase(): string | null {
  const raw =
    typeof process !== "undefined" ? process.env.REACT_APP_LANGFUSE_UI_URL?.trim() : undefined;
  if (!raw) return "https://langfuse.trust-forge.ai";
  return raw.replace(/\/$/, "");
}

/** Default project slug when dataset rows omit projectId (e.g. trustforge-dev). */
export function getLangfuseDefaultProjectId(): string | null {
  const raw =
    typeof process !== "undefined" ? process.env.REACT_APP_LANGFUSE_PROJECT_ID?.trim() : undefined;
  return raw || "trustforge-dev";
}

/**
 * Langfuse UI dataset route uses the internal dataset id in the path.
 * @see https://langfuse.com/docs/evaluation/experiments/datasets
 */
export function buildLangfuseDatasetUrl(
  baseUrl: string,
  projectId: string,
  datasetId: string,
): string {
  const base = baseUrl.replace(/\/$/, "");
  return `${base}/project/${encodeURIComponent(projectId)}/datasets/${encodeURIComponent(datasetId)}/items`;
}
